import { authHeader, utils } from "../helpers";

interface User {
    id: string;
    email: string;
    name: string;
}

type QrLoginStatus = "pending" | "scanned" | "approved" | "rejected" | "expired";

interface QrLoginStartResponse {
    status: QrLoginStatus;
    token: string;
    qr_payload: string;
    expires_at: string;
    expires_in: number;
    check_url?: string;
}

interface QrLoginStatusResponse extends Partial<QrLoginStartResponse> {
    access_token?: string;
    token_type?: string;
    user?: User;
}

interface Config {
    apiUrl: string | undefined;
}

const config: Config = {
    apiUrl: process.env.REACT_APP_API_URL,
};

export const userService = {
    getProfile,
    logout,
    loginGoogle,
    login,
    startQrLogin,
    checkQrLoginStatus,
    loginMicrosoft
};

async function getProfile(): Promise<User> {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader(),
    };

    try {
        const response = await fetch(`${config.apiUrl}/api/profile/me`, requestOptions);
        const user = await utils.handleAuthResponse(response);
        return user;
    } catch (error) {
        logout();
        return Promise.reject(error);
    }
}

async function loginGoogle(credentials: any){
    const requestOptions: RequestInit = {
        method: "POST",
        body: JSON.stringify(credentials),
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    }

    const response = await fetch(`${config.apiUrl}/api/social-login/google`, requestOptions)
    const data = await response.json()
    return data
}

async function loginMicrosoft(credentials: any){
    const requestOptions: RequestInit = {
        method: "POST",
        body: JSON.stringify(credentials),
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    }

    const response = await fetch(`${config.apiUrl}/api/social-login/microsoft`, requestOptions)
    const data = await response.json()
    return data
}

async function login(email: string, password: string){
    const requestOptions: RequestInit = {
        method: "POST",
        body: JSON.stringify({email, password}),
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    }

    const response = await fetch(`${config.apiUrl}/api/login`, requestOptions)
    const data = await response.json()
    return data
}

async function startQrLogin(): Promise<QrLoginStartResponse> {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    }

    const response = await fetch(`${config.apiUrl}/api/qr-login`, requestOptions)
    const data = await utils.handleResponse(response)
    return data as QrLoginStartResponse
}

async function checkQrLoginStatus(token: string): Promise<QrLoginStatusResponse> {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    }

    const response = await fetch(`${config.apiUrl}/api/qr-login/${token}`, requestOptions)
    const data = await utils.handleResponse(response)
    return data as QrLoginStatusResponse
}


async function logout(): Promise<boolean> {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
    };
    try {
        await fetch(`${config.apiUrl}/api/logout`, requestOptions)
            .then(() => {
                utils.deletePasswordToken();
                return true
            });
        return true;
    } catch (error) {
        return await Promise.reject(error);
    }
}
